import React from 'react'
import { Path, FieldValues } from 'react-hook-form'
import './CodeBlockField.css'
import ReactMarkdown from 'react-markdown'
import { RequiredIndicator } from './RequiredIndicator'

interface CodeBlockProps<TFormValues extends FieldValues> {
  name: Path<TFormValues>
  label: string
  description?: string
  message: string
  required?: boolean
}

export function CodeBlockField<TFormValues extends FieldValues>({
  name,
  label,
  description,
  message,
  required = false,
}: CodeBlockProps<TFormValues>) {
  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label}
        {required && <RequiredIndicator />}
      </label>
      {description && (
        <div className="description">
          <ReactMarkdown children={description} />
        </div>
      )}
      <div className="code-block">
        <pre> {message} </pre>
      </div>
    </div>
  )
}
